import {useSelector} from "react-redux";
import UserAccess from "./user-access";
import {
    normalizeMembershipEntity,
    prepareMembershipPayload,
} from "../workspace-membership/workspace-membership-identity";

const accessPopulate = {
    workspace_membership: {populate: {member: {populate: "profileImage"}}},
    workspace: true,
};

export function useUserAccess() {
    const workspaceMembership = useSelector((state) => state.app?.workspaceMembershipData);
    const memberships = workspaceMembership?.workspace?.workspace_memberships || [];
    const getUserAccesses = async (workspaceId, role)=>{
        try {
            const userAccess = new UserAccess();
            const query = {
                filters: {
                    $and:[
                        {workspace:{$eq: workspaceId}},
                        {role:{$eq: role}},
                    ],
                },
                populate: accessPopulate,
            }
            const _data = await userAccess.getAll(query);

            return (_data.data || []).map((item) =>
                normalizeMembershipEntity(item, "userRole", memberships))
        }catch (e){
            throw e;
        }
    }

    const getUserAccess = async (workspaceMembershipId)=>{
        try {
            const userAccess = new UserAccess();
            const query = {
                filters: {
                    $and:[
                        {workspace_membership:{$eq: workspaceMembershipId}},
                    ],
                },
                populate: accessPopulate,
            }
            const _data = await userAccess.getAll(query);

            return (_data.data || []).map((item) =>
                normalizeMembershipEntity(item, "userRole", memberships))
        }catch (e){
            throw e;
        }
    }

    const updateUserAccess = async (userAccessId, userAccessData)=>{
        // if (!permission.can("user-access.update", true))return;
        try {
            const userAccess = new UserAccess();
            const query = {populate: accessPopulate};
            const payload = prepareMembershipPayload("userRole", userAccessData, memberships, {
                currentMembership: workspaceMembership,
                operation: "update",
            });
            const _data = await userAccess.update(userAccessId, payload, query);
            return normalizeMembershipEntity(_data.data, "userRole", memberships)
        }catch (e){
            throw e;
        }
    }

    const createUserAccess = async (userAccessData)=>{
        // if (!permission.can("user-access.create", true))return;
        try {
            const userAccess = new UserAccess();
            const query = {populate: accessPopulate};
            const payload = prepareMembershipPayload("userRole", userAccessData, memberships, {
                currentMembership: workspaceMembership,
                operation: "create",
            });
            const _data = await userAccess.create(payload, query);
            return normalizeMembershipEntity(_data.data, "userRole", memberships)
        }catch (e){
            throw e;
        }
    }
    const removeUserAccess = async (userAccessId)=>{
        // if (!permission.can("user-access.create", true))return;
        try {
            const userAccess = new UserAccess();
            const _data = await userAccess.delete(userAccessId);
            return _data.data
        }catch (e){
            throw e;
        }
    }

    const normalizeWorkspaceRole = (item) => (
        normalizeMembershipEntity(item, "userRole", memberships)
    );

    const getWorkspaceAccessRoles = async () => {
        const userAccess = new UserAccess();
        const response = await userAccess.getWorkspaceAccessRoles();
        return (response?.data || []).map(normalizeWorkspaceRole);
    };

    const getScopedAccessRoles = async (scopeType, scopeId) => {
        const userAccess = new UserAccess();
        const response = await userAccess.getScopedAccessRoles(scopeType, scopeId);
        return (response?.data || []).map(normalizeWorkspaceRole);
    };

    const promoteWorkspaceAdmin = async (workspaceMembershipId, permissions = []) => {
        const userAccess = new UserAccess();
        const response = await userAccess.promoteWorkspaceAdmin(workspaceMembershipId, permissions);
        return normalizeWorkspaceRole(response?.data);
    };

    const updateWorkspaceAdmin = async (documentId, permissions = []) => {
        const userAccess = new UserAccess();
        const response = await userAccess.updateWorkspaceAdmin(documentId, permissions);
        return normalizeWorkspaceRole(response?.data);
    };

    const demoteWorkspaceAdmin = async (documentId) => {
        const userAccess = new UserAccess();
        const response = await userAccess.demoteWorkspaceAdmin(documentId);
        return normalizeWorkspaceRole(response?.data);
    };




    return {
        getUserAccess,
        updateUserAccess,
        createUserAccess,
        getUserAccesses,
        removeUserAccess,
        getWorkspaceAccessRoles,
        getScopedAccessRoles,
        promoteWorkspaceAdmin,
        updateWorkspaceAdmin,
        demoteWorkspaceAdmin,
    };
}
